import React from 'react';
import { EnvironmentalImpact } from '../../services/dailyReportService';

interface EnvironmentalImpactCardProps {
  impact: EnvironmentalImpact;
}

export const EnvironmentalImpactCard: React.FC<EnvironmentalImpactCardProps> = ({ impact }) => {
  return (
    <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg shadow-md p-6 min-h-[160px]">
      <h3 className="text-lg font-semibold text-green-800 mb-6">Environmental Impact</h3>
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <span className="text-sm text-green-700">CO₂ Saved</span>
          <span className="text-xl font-bold text-green-600">{impact.co2_saved_tons.toFixed(2)} tons</span>
        </div>
        
        <div className="flex justify-between items-center">
          <span className="text-sm text-emerald-700">Trees Equivalent</span>
          <span className="text-xl font-bold text-emerald-600">{Math.round(impact.trees_equivalent)}</span>
        </div>
        
        <div className="flex justify-between items-center">
          <span className="text-sm text-teal-700">Car Miles Offset</span>
          <span className="text-xl font-bold text-teal-600">{Math.round(impact.cars_off_road_days)}</span>
        </div>
      </div>
    </div>
  );
};